import styled from "styled-components";
export const Container = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 2em;
  .ant-divider-horizontal {
    margin: 0;
  }
  .ant-timeline {
    max-height: 40em;
    overflow-y: scroll;
    padding: 0.5em 0;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 0.5em;
`;
